const copyText = function (text, success) {
    const textarea = document.createElement('textarea');
    const currentFocus = document.activeElement;
    let state = null;

    document.body.appendChild(textarea);
    textarea.value = text;
    textarea.focus();
    if (textarea.setSelectionRange) {
        textarea.setSelectionRange(0, textarea.value.length);
    } else {
        textarea.select();
    }
    try {
        state = document.execCommand('copy');
    } catch (err) {
        state = false;
    }
    if (success) {
        success();
    }
    document.body.removeChild(textarea);
    currentFocus.focus();
    return state;
};

const bindEvent = (el, { text, success }) => {
    el.onclick = () => {
        copyText(text, success);
    };
};

export default {
    bind(el, params) {
        bindEvent(el, params.value);
    },
    update(el, params) {
        bindEvent(el, params.value);
    },
};
